import styled from "styled-components";
import { ControllerSitInMemberListItem } from "../../../../sit-in/style";

export const MobileTimerControllerSitInWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const MobileControllerSitInInputWrapper = styled.div`
  flex: 1;
  height: 25px;
  border-radius: 15px;
  padding: 5.5px 10px;
  border: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  background: #fff;

  > input {
    outline: none;
    width: 100%;
    height: 100%;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 12px;
    background: #fff;
    border: none;
    color: #121212;
  }

  > img {
    cursor: pointer;
  }
`;

export const MobileControllerSitInHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  > .box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
`;

export const MobileControllerSitInHeaderTabs = styled.div`
  display: flex;
  gap: 10px;

  > .button {
    width: auto;
    padding: 0 10px;
    height: 25px;
    border-radius: 100px;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 14px;
    line-height: 25px;
    text-align: center;
    color: #fff;

    &.select {
      background: #6436e7;
      color: #fff;
    }
  }
`;

export const MobileControllerSitInButtonWrapper = styled.div`
  display: flex;
  gap: 10px;

  > .button {
    background: #7f25fb;
    width: 50px;
    height: 25px;
    border-radius: 100px;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 14px;
    line-height: 25px;
    text-align: center;
    color: #fff;
  }
`;

export const MobileControllerSitInMemberListWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: normal;
  gap: 4.5px;
  color: #fff;

  .name {
    width: 20%;
  }

  .count {
    width: 13%;
  }

  .button {
    width: 13%;
  }

  .more {
    width: 12px;
  }

  .return {
    width: 45%;
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    box-sizing: border-box;
    padding-right: 15px;
    cursor: pointer;
  }
`;

export const MobileControllerSitInMemberListHeader = styled.div`
  display: flex;
  font-family: Pretendard;
  font-weight: 400;
  font-size: 11px;
  text-align: center;
  gap: 6px;
`;

export const MobileControllerSitInMemberListBody = styled.div<{
  height: string;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 10px;
  height: ${({ height }) => height};
  overflow: hidden;
  overflow-y: auto;
`;

export const MobileControllerSitInMemberListItem = styled(
  ControllerSitInMemberListItem
)`
  flex: none;
  height: 34px;
  border-radius: 8px;
  font-size: 11px;

  > .name {
    font-weight: 600;
  }

  > .button {
    height: 24px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 9px;
    line-height: 24px;
  }

  > .more {
    display: flex;
    justify-content: center;
    cursor: pointer;
    position: relative;

    > img {
      height: 24px;
      width: auto;
    }
  }

  > .return {
    > img {
      height: 24px;
      width: auto;
    }
  }
`;
